/**
 * 일체선택형 옵션 핸들러
 * fetchOption 직후 fetchOptionVariant를 해서 variant를 옵션처럼 보여줌
 */
import { BaseOptionHandler } from './BaseOptionHandler';

export class UnifiedOptionHandler extends BaseOptionHandler {

    getRenderableOptions(productOptions, allVariants) {
        if (allVariants.length === 0) {
            return [];
        }
        // if any of the options has optionColor or optionImageFile, set displayType to 'P'
        const displayType = productOptions.some(option => option.value.some(value => value.optionColor !== null || value.optionImageFile !== null)) ? 'P' : 'S';
        
        const getOptionValueByVariantOption = (variantOptionKey, variantOptionValue) => {
            const option = productOptions.find(option => option.optionName === variantOptionKey);
            if (!option) return null;
            const optionValue = option.value.find(value => value.optionText === variantOptionValue);
            return optionValue;
        }

        const getOptionValuesByVariant = (variant) => {
            // variant.options의 각 key-value 쌍에 대해 getOptionValueByVariantOption 호출
            return Object.entries(variant.options).map(([key, value]) => {
                return getOptionValueByVariantOption(key, value);
            }).filter(Boolean); // null 값 제거
        }
        
        return [{
            optionName: Object.keys(allVariants[0].options).join('-'),
            required: true,
            selectedIndex: null,
            selectedValue: null,
            displayType: displayType,
            value: allVariants.map(variant => {
                // variant의 각 옵션에 대한 option value 배열 가져오기
                const optionValues = getOptionValuesByVariant(variant);
                
                // optionImageFile과 optionColor 찾기 (첫 번째 옵션 값에서 가져오거나, 모든 옵션 값 중에서 찾기)
                const optionImageFile = optionValues.find(ov => ov?.optionImageFile)?.optionImageFile || null;
                const optionColor = optionValues.find(ov => ov?.optionColor)?.optionColor || null;
                
                return {
                    ...variant,
                    optionText: Object.values(variant.options).join(' - '),
                    optionImageFile: optionImageFile,
                    optionColor: optionColor
                };
            }),
        }]
    }
    /**
     * 옵션 선택 시: variant가 이미 로드되어 있으므로 즉시 상품 추가
     */
    async onOptionSelect(props) {
        const { 
            optionIndex, 
            selectedIdx, 
            productOptions, 
            renderableOptions, 
            textAndFileOptions,
            optionSelectedProductList,
            setProductOptions, 
            setRenderableOptions, 
            setOptionSelectedProductList
        } = props;

        const selectedOptionValue = renderableOptions[optionIndex].value[selectedIdx];

        // 동일한 옵션 조합이 이미 있는지 확인
        const combination = selectedOptionValue?.optionText;
        if (combination) {
            // 이미 존재하는 combination이면 그냥 종료
            if (optionSelectedProductList.some(product => product.combination === combination)) {
                this.combinationAlreadyExistsToast();
                return;
            }
            // 최대 품목 개수 체크
            if (optionSelectedProductList.length === this.MAX_QUANTITY) {
                this.maxNumberOfProductsToast();
                return;
            }
            
            // 상품 추가
            setOptionSelectedProductList(prev => [...prev, {
                productName: this.productInfo?.name,
                combination: combination,
                noOptionText: false,
                optionValueList: Object.values(selectedOptionValue.options),
                textOptions: textAndFileOptions,
                quantity: 1,
                setQuantity: (quantity) => this.handleQuantityChange(combination, quantity),
                price: this.productInfo?.price,
                additionalPrice: selectedOptionValue.additionalPrice,
                processProductDeleteClicked: () => this.handleProductDeleteClicked(combination),
                variantId: selectedOptionValue.variantId,
            }]);
        }
    }
}

